// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__Nszx8","modalContent":"modal_modalContent__wa66a","modalClose":"modal_modalClose__K3DHA"};